var cilColumns = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M472,48H40A24.028,24.028,0,0,0,16,72V448a24.028,24.028,0,0,0,24,24H472a24.028,24.028,0,0,0,24-24V72A24.028,24.028,0,0,0,472,48Zm-8,32v64H48V80ZM48,176H240V440H48ZM272,440V176H464V440Z' class='ci-primary'/>"];

export { cilColumns };

